import { z } from "zod";
import { stagingDiversionShape } from "../../../SystemSettingsStagingDiversion/SystemSettingsStagingDiversion.types";

/** Mirrors backend `EmrStagingEntry` in system_settings_models.py. */
export const emrStagingSchema = z.object({
  runner_role_arn: z.string().catch(""),
  ...stagingDiversionShape,
  enabled: z.boolean().catch(true),
});

export type EmrStagingEntry = z.infer<typeof emrStagingSchema>;

const EMPTY_ENTRY = emrStagingSchema.parse({});

export const parseEmrStagingIntegrations = (raw: unknown): EmrStagingEntry[] =>
  z.array(emrStagingSchema.catch(EMPTY_ENTRY)).catch([]).parse(raw);

export interface EmrStagingIntegrationFormProps {
  entry: EmrStagingEntry;
  onChange: (entry: EmrStagingEntry) => void;
}
